import './bigguysbbq/style';
import FormStructure from './bigguysbbq/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// c:/_Development/Web Inquiry/inquiry-renderer/client_forms/includes.js